import { Alert, Box, Typography, CssBaseline, ThemeProvider } from '@mui/material';
import { useHistory } from 'react-router-dom';

import themev5 from '../../themev5';
import useSnapshotComparisonList from './hooks/useSnapshotComparisonList';
import useClearSnapshotComparisonListStateOnLeave from './hooks/useClearSnapshotComparisonListStateOnLeave';
import SnapshotComparisonFilters from './components/SnapshotComparisonFilters';
import SnapshotComparisonTable from './components/SnapshotComparisonTable';
import styles from './styles';

const SnapshotComparison = () => {
  const history = useHistory();
  useClearSnapshotComparisonListStateOnLeave();
  const {
    rows,
    total,
    loading,
    error,
    page,
    pageSize,
    filters,
    setCenter,
    setQcStatus,
    setChangeDetectionStatus,
    setEscalatedStatus,
    setAllVerdictFalse,
    setApplicationNumber,
    clearFilters,
    changePage,
    changePageSize
  } = useSnapshotComparisonList();

  const editApplication = (applicationNumber: string) => {
    // encodeURIComponent keeps special characters safe in the URL segment.
    history.push(`/snapshot-comparison/${encodeURIComponent(applicationNumber)}`);
  };

  return (
    <ThemeProvider theme={themev5}>
      <CssBaseline />
      <Box sx={styles.page}>
        <Typography variant='h5' gutterBottom>
          Snapshot Comparison
        </Typography>

        <SnapshotComparisonFilters
          filters={filters}
          onCenterChange={setCenter}
          onQcStatusChange={setQcStatus}
          onChangeDetectionStatusChange={setChangeDetectionStatus}
          onEscalatedStatusChange={setEscalatedStatus}
          onAllVerdictFalseChange={setAllVerdictFalse}
          onApplicationNumberSearch={setApplicationNumber}
          onClear={clearFilters}
        />

        {error && (
          <Box sx={styles.errorContainer}>
            <Alert severity='error'>{error}</Alert>
          </Box>
        )}

        <SnapshotComparisonTable
          rows={rows}
          total={total}
          loading={loading}
          page={page}
          pageSize={pageSize}
          onPageChange={changePage}
          onPageSizeChange={changePageSize}
          onEditApplication={editApplication}
        />
      </Box>
    </ThemeProvider>
  );
};

export default SnapshotComparison;
